import { Component, OnInit, ChangeDetectorRef, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { ENDPOINTS } from 'app/app.config';
// import { MultipleDatePicker } from 'multiple-date-picker';
import { parseZone, Moment, isMoment } from 'moment'
import {IMyDpOptions} from "mydatepicker";


@Component({
  selector: 'app-active-dates-modal',
  templateUrl: './active-dates-modal.component.html',
  styleUrls: ['./active-dates-modal.component.css'],
})
export class ActiveDatesModalComponent  implements OnInit, AfterViewInit, OnChanges {


  @Input()
  playlist: any;
  @Input()
  companyId: any;

  dateModel: any;
  dateModelError: boolean;

  selectedDates: Date[] = [];
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
  };

  @Output('activeDates')
  activeDates = new EventEmitter<string[]>();

  @Output('hasDates')
  hasDates = new EventEmitter<boolean>();

  private dateSortFunc = (d1, d2) => d1.getTime() - d2.getTime();

  constructor() {
  }

  ngOnInit() {

    // console.log(this.playlist)
  }

  ngAfterViewInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedDates.length <= 0 && this.playlist && this.playlist.active_dates != null && this.playlist.active_dates.length > 0) {
      this.selectedDates = this.playlist.active_dates
        .map(d => new Date(d))
        .sort(this.dateSortFunc);
      this.hasDates.emit(this.selectedDates.length > 0);
    }
  }

  updatePlaylist() {
    const selDates = this.selectedDates.map(d => `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`);

    this.hasDates.emit(selDates.length > 0);

    if (this.playlist) {
      this.playlist.active_dates = selDates;

      axios
        .put(
          ENDPOINTS.PLAYLIST.replace(':companyId', this.companyId) +
            '/' +
            this.playlist.id,
          this.playlist,
        )
        .then(response => {}, error => {});
    } else {
      this.activeDates.emit(selDates)
    }
  }

  dateChanged(date: any) {
    if (date && date.formatted.length > 0) {
      const ourCurrentDate = new Date(date.date.year, date.date.month - 1, date.date.day);

      if (this.selectedDates.findIndex(d => ourCurrentDate.getFullYear() == d.getFullYear() && ourCurrentDate.getMonth() == d.getMonth() &&  ourCurrentDate.getDate() == d.getDate()) >= 0) {
        this.dateModelError = true;
      } else {
        this.dateModelError = false;
      }

      if (!this.dateModelError && this.getDisabledDayBefore() > ourCurrentDate) {
        this.dateModelError = true;
      }

      if (!this.dateModelError && this.getDisabledDayAfter() && ourCurrentDate > this.getDisabledDayAfter()) {
        this.dateModelError = true;
      }
    }
  }

  addDate() {
    if (!this.dateModelError && this.dateModel) {
      const ourCurrentDate = new Date(this.dateModel.date.year, this.dateModel.date.month - 1, this.dateModel.date.day);
      this.selectedDates.push(ourCurrentDate);
      this.selectedDates.sort(this.dateSortFunc)
      this.dateModel = null;

      this.updatePlaylist();
    }
  }

  getDisabledDayBefore(): Date {
    if (this.playlist) {
      const date = new Date(this.playlist.published_date);

      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(0);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    }
    return null;
  }

  getDisabledDayAfter(): Date {
    if (this.playlist && this.playlist.expire_date) {
      const date = new Date(this.playlist.expire_date);

      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(0);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    }
    return null;
  }

  removeSelectedDayByIndex(index: number) {
    this.selectedDates.splice(index, 1);
    this.updatePlaylist();
  }

  clear() {
    this.selectedDates = [];
    this.hasDates.emit(false);
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/active-dates-modal/active-dates-modal.component.ts